import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { resendValEmail } from '../../api/SignupService';
import { TextField } from '../inputs';
import CBButton from '../Buttons/CbButton';
import NextPublicWrapper from './NextPublicWrapper';

function ResendValidationEmail() {
  const [email, setEmail] = useState('');
  const [submitEmail, setSubmitEmail] = useState(false);

  const handleChange = (e: any) => setEmail(e.target.value);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const { elements } = event.target;
    resendValEmail(elements.email.value);
    setSubmitEmail(true);
    setEmail('');
  };

  return (
    <NextPublicWrapper>
      <div style={{ marginTop: 16 }}>
        {!submitEmail && (
          <form onSubmit={handleSubmit}>
            <Typography>
              Enter your email to resend your validation email.
            </Typography>

            <TextField
              id="email"
              type="email"
              label="Email"
              value={email}
              required
              onChange={handleChange}
            />

            <CBButton
              size="large"
              type="submit"
              styleName="ctaButton"
              buttonText="Resend Validation Email"
              style={{ marginTop: '2rem' }}
            />
          </form>
        )}
        {submitEmail && (
          <Typography>
            A validation email has been sent to your email address
          </Typography>
        )}
      </div>
    </NextPublicWrapper>
  );
}

export default ResendValidationEmail;
